var React = require('react');

function SearchMain (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M11.348 6.174a5.174 5.174 0 1 1-10.35-.001 5.174 5.174 0 0 1 10.35 0zM9.841 9.84 15 14.999"})));
}

SearchMain.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = SearchMain;

SearchMain.default = SearchMain;
